<style>
.SiOfferListWidget__request__toggler {
  position: fixed;
  top: 0.25rem;
  right: 0.25rem;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  color: inherit;
  z-index: 2;
  background-image: url("~@/assets/close.svg");
  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
  appearance: none;
  margin: 0;
  cursor: pointer;
}
.SiOfferListWidget__requestOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: rgba(100, 100, 100, 0.9);
  z-index: 100000;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
}
.SiOfferListWidget__offerDetailsWrapper {
  position: relative;
  width: 95%;
  max-height: 95%;
  max-width: 40rem;
  background: #fff;
  overflow-y: auto;
  margin: auto;
  padding: 1rem;
  border-radius: 0.4rem;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch; /*iPhone fix*/
}
.SiOfferListWidget__offerDetailsTitle {
  margin: 0 0 0.5rem;
  max-width: calc(100% - 2rem);
  text-align: left;
}
.SiOfferListWidget__offerDetailsDescription {
  margin-bottom: 1rem;
  text-align: left;
  white-space: pre-line;
  overflow: hidden;
}

.SiOfferListWidget__offerImageWrapper {
  width: 100%;
  border-radius: 0.4rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  text-align: center;
}

.SiOfferListWidget__offerImage {
  max-width: 400px;
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 0.4rem;
}

.SiOfferListWidget__offerDetailsTimePeriodsWrapper {
  background-color: #f3f3f3;
  border-radius: 0.4rem;
  box-sizing: border-box;
  padding: 0.4rem 0.6rem;
  text-align: left;
  width: 100%;
  margin-bottom: 1rem;
}

.SiOfferListWidget__offerDetailsInclusivesWrapper {
  margin-bottom: 1rem;
  text-align: left;
}

.SiOfferListWidget__offerDetailsInclusivesWrapper ul {
  padding: 0 0 0 1.5rem;
  list-style: initial;
}

.SiOfferListWidget__offerDetails__HotelInfo {
  background-color: #f3f3f3;
  border-radius: 0.4rem;
  padding: 1rem;
  text-align: center;
}

.SiOfferListWidget__offerDetails__AccommodationImage {
  object-fit: cover;
  border-radius: 0.4rem;
  margin-bottom: 1rem;
  width: 100%;
  height: 200px;
}

@media (min-width: 40rem) {
  .SiOfferListWidget__offerDetails__AccommodationImages {
    display: flex;
    justify-content: space-between;
    height: 250px;
    margin-bottom: 1rem;
  }

  .SiOfferListWidget__offerDetails__AccommodationImage {
    border-radius: 0.4rem;
    margin-bottom: 0;
    width: calc(50% - 10px);
    height: 100%;
  }
}

.SiOfferListWidget__offerDetails__Classification {
  display: inline-block;
  position: relative;
  width: auto;
}

.SiOfferListWidget__offerDetails__HotelName {
  font-size: 1.2rem;
  font-weight: bold;
}

.SiOfferListWidget__offerDetails__HotelPlace {
  font-size: 0.9rem;
}

.SiOfferListWidget__detailLink {
  display: inline-block;
  text-decoration: none;
  line-height: 2;
  border-radius: 2rem;
  cursor: pointer;
  border: none;
  padding: 0 1.5rem 0 1.5rem;
  font-size: 1rem;
  background-color: #2c2b30;
  background: var(--ctaButton-bg);
  color: #fff;
  color: var(--ctaButton-color);
  transition: transform 0.1s cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 0.1s cubic-bezier(0.23, 1, 0.32, 1);
  font-weight: 700;
  letter-spacing: 0.04rem;
  margin-top: 1rem;
}
.SiOfferListWidget__detailLink:hover,
.SiOfferListWidget__listElement:hover .SiOfferListWidget__detailLink {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.3);
  color: #fff;
  color: var(--ctaButton-color);
}
.SiOfferListWidget__detailLink:active {
  transform: scale(0.98);
}
.SiOfferListWidget__detailLink:focus {
  outline: 1px dashed #aaa;
  outline-offset: 2px;
}

.SiOfferListWidget__requestLink {
  display: inline-block;
  text-decoration: none;
  line-height: 2;
  border-radius: 2rem;
  cursor: pointer;
  border: none;
  padding: 0 1.5rem 0 1.5rem;
  font-family: inherit;
  font-size: 1rem;
  margin-top: 0.4rem;
  margin-bottom: 1rem;
  background-color: #2c2b30;
  background: var(--ctaButton-bg);
  color: #fff;
  color: var(--ctaButton-color);
  transition: transform 0.1s cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 0.1s cubic-bezier(0.23, 1, 0.32, 1);
  font-weight: 700;
  letter-spacing: 0.04rem;
}
.SiOfferListWidget__requestLink:hover,
.SiOfferListWidget__listElement:hover .SiOfferListWidget__requestLink {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.3);
  color: #fff;
  color: var(--ctaButton-color);
}
.SiOfferListWidget__requestLink:active {
  transform: scale(0.98);
}
.SiOfferListWidget__requestLink:focus {
  outline: 1px dashed #aaa;
  outline-offset: 2px;
}

#SiOfferListWidget__requestIframe {
  height: 100%;
  width: 100%;
  border: none;
  box-sizing: border-box;
  margin-top: 1rem;
}

@media screen and (min-width: 35rem) {
  .SiOfferListWidget__offerImageWrapper {
    width: 250px;
    float: left;
  }

  .SiOfferListWidget__offerImage {
    width: 100%;
    object-fit: initial;
  }
}
</style>

<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div
      v-if="widgetState.showRequest && widgetState.selectedOffer !== undefined"
      class="SiOfferListWidget__requestOverlay"
      @click.self="toggleRequest"
    >
      <div class="SiOfferListWidget__offerDetailsWrapper">
        <h1 class="SiOfferListWidget__offerDetailsTitle">
          {{ widgetState.selectedOffer.title }}
        </h1>
        <div
          v-if="widgetState.selectedOffer !== undefined"
          class="SiOfferListWidget__offerDetailsDescription"
        >
          <div class="SiOfferListWidget__offerImageWrapper">
            <img
              class="SiOfferListWidget__offerImage"
              :src="getFullImgUrl(widgetState.selectedOffer.image)"
              :srcset="getSrcset(widgetState.selectedOffer.image)"
              sizes="400px"
            >
          </div>
          <div>
            {{ widgetState.selectedOffer.preview_text | sanitize }}
          </div>
        </div>
        <div class="SiOfferListWidget__offerDetailsTimePeriodsWrapper">
          <b>{{ textState.texts.timePeriods }}:</b>
          <div
            v-for="(timePeriod, index) in widgetState.selectedOffer.rates"
            :key="index"
            class="SiOfferListWidget__offerDetailsTimePeriods"
          >
            {{ timePeriod.start_date | formatDate }} -
            {{ timePeriod.end_date | formatDate }}: {{ timePeriod.duration }}
            {{
              timePeriod.duration > 1
                ? textState.texts.nights
                : textState.texts.night
            }}
            {{ textState.texts.startingAt }}
            <b>{{ timePeriod.new_rate | formatPrice }}</b>
            {{ textState.texts.perPerson }}
          </div>
        </div>
        <div>
          <button
            class="SiOfferListWidget__requestLink"
            target="_blank"
            type="button"
            @click="goToRequest"
          >
            {{ textState.texts.toInquiry }}
          </button>
        </div>
        <div
          v-if="widgetState.selectedOffer.rate_services.length > 0"
          class="SiOfferListWidget__offerDetailsInclusivesWrapper"
        >
          <b>{{ textState.texts.inclusiveServices }}:</b>
          <ul>
            <li
              v-for="(rateService, index) in widgetState.selectedOffer.rate_services"
              :key="index"
              class="SiOfferListWidget__offerDetailsInclusives"
            >
              {{ rateService.name }}
            </li>
          </ul>
        </div>

        <div
          v-if="widgetState.selectedOffer.detail_text !== undefined && widgetState.selectedOffer.detail_text !== null"
          class="SiOfferListWidget__offerDetailsDescription"
        >
          <b>{{ textState.texts.description }}:</b><br>
          {{ widgetState.selectedOffer.detail_text | sanitize }}
        </div>

        <div class="SiOfferListWidget__offerDetails__HotelInfo">
          <div
            v-if="selectedMandantImages.length > 0"
            class="SiOfferListWidget__offerDetails__AccommodationImages"
          >
            <img
              v-for="image in selectedMandantImages"
              :key="image"
              :src="getFullImgUrl(image, '1200x0')"
              :alt="widgetState.selectedOffer.name"
              class="SiOfferListWidget__offerDetails__AccommodationImage"
            >
          </div>
          <div
            class="SiOfferListWidget__offerDetails__Classification"
            v-html="
              getClassification(
                widgetState.selectedOffer.classification_rating,
                widgetState.selectedOffer.superior,
                widgetState.selectedOffer.classification_type
              )
            "
          />
          <div class="SiOfferListWidget__offerDetails__HotelName">
            {{ widgetState.selectedOffer.name }}
          </div>
          <div class="SiOfferListWidget__offerDetails__HotelPlace">
            {{ widgetState.selectedOffer.place }}
            <template
              v-if="widgetState.selectedOffer.fraction != undefined && widgetState.selectedOffer.fraction.length > 0"
            >
              - {{ widgetState.selectedOffer.fraction }}
            </template>
          </div>
          <a
            v-if="widgetStore.getDetailLink(widgetState.selectedOffer) !== null"
            :href="widgetStore.getDetailLink(widgetState.selectedOffer)"
            :data-original-href="widgetStore.getDetailLink(widgetState.selectedOffer).toString()"
            :data-link-type-id="widgetState.selectedOffer.link_type_id.toString()"
            class="SiOfferListWidget__detailLink"
            target="_blank"
            rel="sponsored"
            @click="triggerDetailLink"
            @click.middle="triggerDetailLink"
          >
            {{ textState.texts.accommodationDetails }}
          </a>
        </div>

        <img
          v-show="widgetState.requestLoading === true"
          src="@/assets/loader.svg"
          alt
          title
        >
        <iframe
          id="SiOfferListWidget__requestIframe"
          src="about:blank"
        />
      </div>
      <button
        class="SiOfferListWidget__request__toggler"
        type="button"
        @click.self="toggleRequest"
      />
    </div>
  </div>
</template>

<script>
import textsStore from "@/stores/texts";
import widgetStore from "@/stores/widget";
import iframeInquiryString from "@/utils/iframeInquiryString";
import getClassificationHtml from "@/utils/getClassificationHtml";

export default {
  name: "RequestComponent",
  filters: {
    formatDate(value) {
      return formatDate(value);
    },
    formatPrice(value) {
      return formatPrice(value);
    },
    sanitize(value) {
      return value.trim().replace(/<br \/>|<br\/>|<\/ br>|<\/br>/gim, "\r\n");
    }
  },
  data() {
    return {
      textState: textsStore.state,
      widgetState: widgetStore.state,
      widgetStore: widgetStore,
      requestUrl: null,
      selectedMandantImages: []
    };
  },
  async updated() {
    if (
      this.widgetState.showRequest &&
      this.widgetState.selectedOffer !== undefined &&
      this.widgetState.requestVisible === false
    ) {
      this.selectedMandantImages = [];

      this.widgetState.requestVisible = true;
      document.body.style.overflowY = "hidden";
      this.createRequestForm(this.widgetState.selectedOffer);

      try {
        const result = (await (await fetch(
          `${process.env.VUE_APP_API_HOST}portal_entry/details?id=${this.widgetState.selectedOffer.mandant_external_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": widgetStore.state.apiKey
            }
          }
        )).json());

        this.selectedMandantImages = [result.image, result.detail_images[0].url];
      } catch (error) {
        console.error(error);
      }
    } else {
      clearInterval(this.interval);
    }
  },
  methods: {
    getClassification: getClassificationHtml,
    goToRequest() {
      const iframe = this.$root.$el.querySelector("#SiOfferListWidget__requestIframe");

      if (iframe !== null) {
        document
          .querySelector(".SiOfferListWidget__offerDetailsWrapper")
          .scrollTo({
            top: iframe.offsetTop - 100,
            behavior: "smooth"
          });

        setTimeout(() => {
          iframe.focus();
        }, 800);
      }
    },
    triggerDetailLink(e) {
      const link = e.target
        .closest(".SiOfferListWidget__offerDetails__HotelInfo")
        .querySelector(".SiOfferListWidget__detailLink");

      const originalHref = link.getAttribute("data-original-href");
      const linkTypeId = link.getAttribute("data-link-type-id");
      const url = new URL(link.href);
      url.searchParams.set("linkTypeId", linkTypeId);
      link.href = url.toString();

      setTimeout(() => {
        link.href = originalHref;
      }, 0);

      if (e.target === link) return false;

      window.open(link.href, link.target);

      return false;
    },
    toggleRequest() {
      if (this.widgetState.showRequest === true) {
        document.body.style.overflowY = "auto";
        this.widgetState.selectedOffer = undefined;
        this.widgetState.showRequest = false;
        this.widgetState.requestVisible = false;
        document.body.removeAttribute("data-siwidget-overlay-shown");
      } else {
        document.body.style.overflowY = "hidden";
        this.widgetState.showRequest = true;
        document.body.setAttribute("data-siwidget-overlay-shown", true);
      }
    },
    async createRequestForm(offer) {
      this.widgetState.requestLoading = true;

      const token = await widgetStore.getRequestToken(offer.mandant_external_id, offer.link_type_id);
      const iframe = this.$el.querySelector("#SiOfferListWidget__requestIframe");

      const offerTitle = offer.title;
      const offerPreviewText = offer.preview_text;
      let offerTimePeriods = "";
      for (const timePeriod of offer.rates ?? []) {
        offerTimePeriods += `${formatDate(
          timePeriod.start_date
        )} - ${formatDate(timePeriod.end_date)}: ${timePeriod.duration} ${
          timePeriod.duration > 1
            ? this.textState.texts.nights
            : this.textState.texts.night
        } ${this.textState.texts.startingAt} ${formatPrice(
          timePeriod.new_rate
        )} ${this.textState.texts.perPerson}\n`;
      }

      if (iframe !== null) {
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.writeln(iframeInquiryString(token, this.widgetState.language));
        doc.close();

        const comment = `${offerTitle.trim()}

${offerPreviewText}

${offerTimePeriods}`;
        iframe.contentWindow.window.setFields({ comment });

        setInterval(() => {
          const form = doc.querySelector("#eassistant");
          if (form === null) return;

          const iframeHeight = iframe.clientHeight;
          const iframeContentHeight = form.offsetHeight + form.offsetTop * 2;

          if (iframeHeight != iframeContentHeight) {
            iframe.style.height = iframeContentHeight + "px";
          }
        }, 500);
      }

      this.widgetState.requestLoading = false;
    },
    getFullImgUrl(name, size = "400x267") {
      return (
        process.env.VUE_APP_EASSISTANT_IMAGE_HOST +
        "originals/" +
        size +
        "/" +
        name
      );
    },
    getSrcset(name) {
      return `${process.env.VUE_APP_EASSISTANT_IMAGE_HOST}originals/400x267/${name} 400w,
        ${process.env.VUE_APP_EASSISTANT_IMAGE_HOST}originals/800x534/${name} 800w`;
    }
  }
};

function formatDate(value) {
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour12: false
  }).format(new Date(value));
}

function formatPrice(value) {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "EUR"
  }).format(value);
}
</script>
